module.exports = __webpack_public_path__ + "img/icon_map_ytzy.2e7ebf8d.png";